import http from "../http-common";
import authHeader from "./auth-header";
const API_URL = "/auth/";

class AuthService {
    login(data, login_type) {
        return http.post(API_URL + "signin", { data, login_type }).then((response) => {
            if (response.data.accessToken) {
                localStorage.setItem("user", JSON.stringify(response.data));
                localStorage.setItem("loginType", login_type);
            }
            return response.data;
        });
    }
    logout() {
        localStorage.removeItem("user");
        localStorage.removeItem("loginType");
    }
    register(username, email, password) {
        return http.post(API_URL + "signup", {
            username,
            email,
            password,
        });
    }
    changePassword(id, newPassword, oldPassword) {
        return http.put(
            API_URL + "password/update",
            {
                id: id,
                newPassword: newPassword,
                oldPassword: oldPassword,
            },
            { headers: authHeader() },
        );
    }
    checkToken() {
        return http.post(API_URL + "checkToken", {}, { headers: authHeader() });
    }
    impersonate(userId) {
        return http.post(API_URL + "impersonate", { userId }, { headers: authHeader() }).then((response) => {
            const data = response.data;
            if (data.accessToken) {
                // Save the admin's current session as a backup so it can be restored
                // if the impersonation session expires before the admin exits.
                const currentSession = localStorage.getItem("user");
                if (currentSession) {
                    localStorage.setItem("adminSession", currentSession);
                }
                localStorage.setItem("user", JSON.stringify(data));
            }
            return data;
        });
    }
    stopImpersonate() {
        return http.post(API_URL + "stop-impersonate", {}, { headers: authHeader() }).then((response) => {
            const data = response.data;
            if (data.accessToken) {
                localStorage.setItem("user", JSON.stringify(data));
                localStorage.removeItem("adminSession");
            }
            return data;
        });
    }
}
export default new AuthService();
